import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Spin, Checkbox } from 'antd';
import { FilterOutlined, FilterFilled } from '@ant-design/icons';
import { AllCommunityModule, ModuleRegistry, ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import ColSetting from "./ColSetting";
import './style.scss';
import { mixPostV2 } from "../../services/mixin";
import { selectorInfoUser } from '../../store/slices/infoUserSlice';
import { useSelector } from 'react-redux';
import { use } from "echarts";

ModuleRegistry.registerModules([AllCommunityModule]);
const screenDf = 1440; // thiết kế theo
const getWidthFromHeader = (item: any, min = 80, max = 400) => {
  const width = item.headerName.length * 10 + 40;
  let temp = Math.min(Math.max(width, min), max);
  if (item.resizable === false) temp = item.width || 100;
  return temp;
};

const convertWidthV2 = (width: number) => {
  let currentScreenWidth = window.innerWidth;
  if (currentScreenWidth < screenDf) currentScreenWidth = screenDf;
  const columnWidth = Math.round((screenDf * width) / currentScreenWidth);
  return columnWidth;
}
const convertWidthV3 = (width: number) => {
  let currentScreenWidth = window.innerWidth;
  if (currentScreenWidth < screenDf) currentScreenWidth = screenDf;
  const columnWidth = Math.round((currentScreenWidth * width) / screenDf);
  return columnWidth;
}

const maxWidth = convertWidthV3(350);
const minWidth = convertWidthV3(100);

const MagaTableV2 = ({
  stData = {} as any,
  stChange = (data = {}, type = '') => { },
  tbChange = (data = {}, type = '') => { },
}) => {
  const gridRef = useRef(null as any);
  const user = useSelector(selectorInfoUser);

  const [tableColDefs, setTableColDefs] = useState([] as any);

  useEffect(() => {
    if(stData.tableColDefs) {
      stChange({ ...stData, tableColDefs: tableColDefs })
    }
  }, [tableColDefs]);

  // Tính toán rowHeight & selectionColWidth
  const [rowHeight, setRowHeight] = useState(40);
  const [selectionColWidth, setSelectionColWidth] = useState(40);

  const getCache = async () => {
    if (stData.col.length > 0) {
      const res = await mixPostV2(`/api/v1/be/user_thaco_json_more`, {
        user_id_thaco: user.id,
        name: JSON.stringify([stData.name || 'noName']),
      })
      if (res.status) {
        if (res.data.items) {
          const dataJson = JSON.parse(res.data.items && res.data.items[0] ? res.data.items[0].data_json : '{}');
          const temp = [] as any
          stData.col.map((val: any, index: any) => {
            temp.push({
              ...val,
              width: val.resizable === false ? val.width || 100 : dataJson[val.field]?.width || getWidthFromHeader(val),
              hide: dataJson[val.field] !== undefined ? dataJson[val.field]?.hide || false : val.hide || false,
              order: val.lockPosition ? val.order : dataJson[val.field]?.order || index
            })
          })
          temp.sort((a: any, b: any) => a.order - b.order);
          const temp2 = [] as any
          temp.map((col: any) => {
            const item = {
              ...col,
              width: convertWidthV3(col.width || 100),
            }
            if (item.maxWidth) item.maxWidth = convertWidthV3(item.maxWidth);
            if (item.minWidth) item.minWidth = convertWidthV3(item.minWidth);
            delete item.order;
            temp2.push(item)
          });
          setTableColDefs(temp2);
        }
      }
    }
  }

  useEffect(() => {
    getCache();
  }, [stData.col]);

  useEffect(() => {
    const baseFactor = (48 * 100) / 1440 / 100;
    const factor = window.innerWidth > 1440 ? baseFactor * 0.9 : baseFactor;
    const newHeight = Math.round(window.innerWidth * factor);
    setRowHeight(newHeight);
    setSelectionColWidth(newHeight);
  }, []);

  const timeout = useRef<any>(null);
  const [stop, setStop] = useState(true);
  const handleColumnChanged = (e: any) => {
    if (stop) { setStop(false); return; };
    if (timeout.current) clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      const columnStatex = e.api.getColumnDefs();
      matchTabeCol(columnStatex);
    }, 500);
  }

  const matchTabeCol = async (columnStatex: any) => {
    const temp = {} as any
    setTableColDefs(columnStatex);
    setStop(true);
    columnStatex.map((val: any, index: any) => {
      temp[val.field] = {
        width: convertWidthV2(val.width),
        hide: val.hide || false,
        order: index,
      }
    })
    delete temp['row_selected'];
    delete temp['undefined'];
    const param = {
      user_id_thaco: user.id,
      name: stData.name || 'noName',
      data_json: JSON.stringify(temp),
    };
    await mixPostV2('/api/v1/be/user_thaco_json', param);
  }

  const handleRowSelected = useCallback((e: any) => {
    if (stData?.isRowsSelect) {
      const selectedRows = e.api.getSelectedRows();
      stChange({ ...stData, selectedRowKeys: selectedRows });
    }
  }, [stChange, stData?.isRowsSelect]);

  useEffect(() => {
    if (gridRef.current && gridRef.current.api && stData.clearRowSelect) {
      gridRef.current.api.deselectAll();
      stChange({ ...stData, clearRowSelect: false });
    }
  }, [stData.clearRowSelect]);

  const [rowActive, setRowActive] = useState<number>(-1);
  useEffect(() => {
    setRowActive(stData.rowActive);
  }, [stData.rowActive]);

  const NoRowsOverlay = () => <div className="overlay-row-custom"><img src="/no-data.svg" alt="No data" /><div className="text">Không có dữ liệu</div></div>;
  const CustomLoadingOverlay = () => (
    <Spin className="spin-tb-loading" />
  )
  const indeterminate = useMemo(() => {
    if (!stData.objSelect) return false;
    const totalRows = stData.listData ? stData.listData.filter((val: any) => !val.hideCheckBox).length : 0;
    let selectedRowsCount = 0;
    stData.listData.map((val: any) => {
      if (stData?.objSelectData[val.id]) {
        selectedRowsCount++;
      }
    })
    return selectedRowsCount > 0 && selectedRowsCount < totalRows;
  }, [stData.listData, stData.objSelectData]);

  const checkAll = useMemo(() => {
    if (!stData.objSelect) return false;
    const totalRows = stData.listData ? stData.listData.filter((val: any) => !val.hideCheckBox).length : 0;
    let selectedRowsCount = 0;
    stData.listData.map((val: any) => {
      if (stData?.objSelectData[val.id]) {
        selectedRowsCount++;
      }
    })
    return selectedRowsCount === totalRows && totalRows > 0;
  }, [stData.listData, stData.objSelectData]);

  const onCheckAllChange = (e: any) => {
    const newObj = {...stData.objSelectData} as any;
    if (e.target.checked) {
      stData.listData.map((val: any) => {
        if(!val.hideCheckBox) {
          newObj[val.id] = val;
        }
      })
    } else {
      stData.listData.map((val: any) => {
        delete newObj[val.id];
      });
    }
    stChange({ ...stData, objSelectData: newObj })
  };

  return (
    <div className={`ag-theme-alpine empty-test-td custom-table-ag-v2${stData.isRowsSelect ? ' has-row-select' : ''}`} style={{ width: "100%", height: stData.height || 'auto' }}>
      <AgGridReact
        ref={gridRef}
        domLayout={stData.height ? 'normal' : 'autoHeight'}
        rowData={stData.listData || []}
        defaultColDef={{
          resizable: true,
          minWidth: minWidth,
          maxWidth: maxWidth,
          ...stData.defaultColDef || {}
        }}
        getRowStyle={(params: any) => {
          if (params.node.rowIndex === rowActive) {
            return { backgroundColor: '#e6f4ff' }
          }
          if (params?.node?.rowIndex % 2 === 0) {
            return {
              backgroundColor: '#ffffff',
            }
          }
          if (params?.node?.rowIndex % 2 !== 0) {
            return {
              backgroundColor: '#f7f9fc',
            }
          }
        }}
        columnDefs={stData?.objSelect && stData?.objSelectData ? [
          {
            headerName: '',
            headerComponent: () => (<div><Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll} className='rs-checkbox' /></div>),
            field: 'row_selected',
            resizable: false,
            sortable: false,
            filter: false,
            lockPosition: 'left',
            minWidth: convertWidthV3(45),
            maxWidth: convertWidthV3(45),
            cellRenderer: (params: any) => {
              return (
                <div className={`row-selected-item ${params.data.hideCheckBox ? 'd-none' : ''}`}>
                  <Checkbox disabled={params.data.hideCheckBox} className='rs-checkbox' checked={stData.objSelectData[params.data.id]} onChange={(e) => {
                    const newObj = { ...stData.objSelectData };
                    if (e.target.checked) {
                      newObj[params.data.id] = params.data;
                    } else {
                      delete newObj[params.data.id];
                    }
                    stChange({ ...stData, objSelectData: newObj })
                  }} />
                </div>
              )
            },
          },
          ...tableColDefs.filter((col: any) => col.field !== 'row_selected'),
        ] : tableColDefs.map((col: any) => {
          if (col.modalFilter) {
            col.headerComponent = () => (
              <div className={`ctr-filter-agtable ${stData.filterActive[col.field] ? 'active' : ''}`} onClick={() => {
                tbChange({ show: true, field: col.field }, 'modalFilter');
              }}>
                <span>{col.headerName}</span>
                <FilterOutlined className='off' />
                <FilterFilled className='on' />
              </div>
            )
          }
          return col;
        })}
        suppressDragLeaveHidesColumns={true}
        rowHeight={rowHeight}
        loading={stData?.loading || false}
        rowSelection={stData?.isRowsSelect ? { mode: 'multiRow' } : undefined}
        selectionColumnDef={stData?.isRowsSelect ? { width: selectionColWidth } : undefined}
        enableBrowserTooltips={true}
        onColumnResized={handleColumnChanged}
        onColumnMoved={handleColumnChanged}
        onColumnVisible={handleColumnChanged}
        onRowSelected={handleRowSelected}
        noRowsOverlayComponent={NoRowsOverlay}
        loadingOverlayComponent={CustomLoadingOverlay}
        tooltipShowMode={"whenTruncated"}

      />
      <ColSetting stData={{ ...stData }} tableColDefs={tableColDefs} stChange={(data, type) => {
        if (type === 'colDefs') {
          setTableColDefs(data || []);
          matchTabeCol(data);
          stChange({ ...stData, showSetting: false });
        }
        if (type === 'close') {
          stChange({ ...stData, showSetting: false });
        }
      }} />
    </div>
  );
};

export default MagaTableV2;
